var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaoBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-balance",
    clipPath: "url(#clip0_3958_9642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85711 0.857143C8.85711 0.383756 8.47335 0 7.99997 0C7.52657 0 7.14283 0.383756 7.14283 0.857143V15.1435C7.14283 15.6169 7.52657 16.0007 7.99997 16.0007C8.47335 16.0007 8.85711 15.6169 8.85711 15.1435V0.857143ZM4.42827 2.74738C4.90166 2.74738 5.28541 3.13114 5.28541 3.60452V12.3961C5.28541 12.8695 4.90166 13.2533 4.42827 13.2533C3.95488 13.2533 3.57112 12.8695 3.57112 12.3961V3.60452C3.57112 3.13114 3.95488 2.74738 4.42827 2.74738ZM0.856716 5.49476C1.33011 5.49476 1.71385 5.87852 1.71385 6.3519V9.64876C1.71385 10.1222 1.33011 10.5059 0.856716 10.5059C0.383328 10.5059 -0.000427246 10.1222 -0.000427246 9.64876V6.3519C-0.000427246 5.87852 0.383328 5.49476 0.856716 5.49476ZM11.5715 2.74738C12.0449 2.74738 12.4287 3.13114 12.4287 3.60452V12.3961C12.4287 12.8695 12.0449 13.2533 11.5715 13.2533C11.0981 13.2533 10.7144 12.8695 10.7144 12.3961V3.60452C10.7144 3.13114 11.0981 2.74738 11.5715 2.74738ZM16.0003 6.3519C16.0003 5.87852 15.6166 5.49476 15.1432 5.49476C14.6698 5.49476 14.286 5.87852 14.286 6.3519V9.64876C14.286 10.1222 14.6698 10.5059 15.1432 10.5059C15.6166 10.5059 16.0003 10.1222 16.0003 9.64876V6.3519Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3958_9642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaoBalance);
export default __webpack_public_path__ + "static/media/dao_balance.89f979b29cbaff04eb2184c7ea76d458.svg";
export { ForwardRef as ReactComponent };